<app-header
  [isExternal]="true"
  [logo]="logo"
  [color]="color"
></app-header>

<div class="no-assist">
  <img src="/assets/img/no-chat.png" alt="no chat">
  <p>Thank you. The maintenance is closed</p>
</div>
